<template>
    <el-button :loading="csvIsLoading" type="primary" plain @click="downloadCsv">
        {{ getTextButton }}
    </el-button>
</template>

<script>import moment from 'moment';
export default {
    name: 'DownloadCsvButton',


    props: {
        context: {
            type: Object,
            required: true,
        },
        textButton: {
            type: String,
            default: undefined,
        },
        modelName: {
            type: String,
            required: true,
        },
    },

    data: function () {
        return {
            csvIsLoading: false,
        };
    },

    computed: {
        getTextButton() {
            return this.textButton || 'Télécharger l\'XLSX';
        }
    },

    mounted: function () {

    },

    methods: {
        downloadCsv() {
            this.csvIsLoading = true;
            this.$store.dispatch('createItem', {
                item: {
                    context: this.context,
                    status: 'PENDING',
                },
                model: 'exportGenerationRequests',
                url: this.$store.state.api.meta.listModels.exportGenerationRequests.url,

            }).then((response) => {
                this.$store.dispatch('fundation/watchRequestStatus', {
                    url: response.url,
                }).then((res) => {
                    this.downlaodFileFromUrl(res.data.file).then(() => {
                        this.csvIsLoading = false;
                        this.$notify({
                            type: 'success',
                            title: 'CSV téléchargé',
                            message: "Le fichier a été télécharger avec succès",
                        });
                    }).catch((error) => {
                        console.error(error);
                        this.csvIsLoading = false;
                        this.$notify({
                            type: 'error',
                            title: 'Erreur',
                            message: "Le fichier n'a pas pu être téléchargé",
                        });
                    });

                }).catch((error) => {
                    console.error(error);
                    this.$notify({
                        type: 'error',
                        title: 'Erreur',
                        message: "Le fichier n'a pas pu être téléchargé",
                    });
                    this.csvIsLoading = false;
                });
            }).catch((error) => {
                console.error(error);
                this.$notify({
                    type: 'error',
                    title: 'Erreur',
                    message: "Le fichier n'a pas pu être téléchargé",
                });
                this.csvIsLoading = false;
            })

        },
        async downlaodFileFromUrl(url) {
            return await fetch(url)
                .then(response => response.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `export-${moment().format('YYYY-MM-DD-HH-mm')}-${this.modelName}.csv`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                });
        },
    },
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/partials/download-csv-button.vue